import { addHeaders, formatRoutingIdWithFeaturePrefix, getRoutingId } from 'domains/teams/actions';
import { getDecodedMeetingId, getParticipantRegistrationId } from 'domains/teams/selectors';
import type { YammerTeamsEventState } from 'state/types';

export const getTeamsMeetingRelayHeaders = (state: YammerTeamsEventState): Record<string, string> | undefined => {
  const teamsMeetingId = getDecodedMeetingId(state);

  if (!teamsMeetingId) {
    return undefined;
  }

  const routingId = getRoutingId(state);
  const participantRegistrationId = getParticipantRegistrationId(state);

  return {
    'X-Yam-Scope-Type': 'TEAMS_MEETING',
    'X-Yam-Scope-Entity-Id': teamsMeetingId,
    ...addHeaders('X-Yam-TenantId', formatRoutingIdWithFeaturePrefix(routingId)),
    ...addHeaders('X-Yam-Participant-RegistrationId', participantRegistrationId),
  };
};
